export const CART_REQUEST = "CART_REQUEST";
export const CART_REQUEST_SUCCESS = "CART_REQUEST_SUCCESS";
export const CART_REQUEST_ERROR = "CART_REQUEST_ERROR";

export const CART_ADD_REQUEST = "CART_ADD_REQUEST";
export const CART_ADD_SUCCESS = "CART_ADD_SUCCESS";
export const CART_ADD_ERROR = "CART_ADD_ERROR";

export const CART_UPDATE_REQUEST = "CART_UPDATE_REQUEST";
export const CART_UPDATE_SUCCESS = "CART_UPDATE_SUCCESS";
export const CART_UPDATE_ERROR = "CART_UPDATE_ERROR";

export const CART_DELETE_REQUEST = "CART_DELETE_REQUEST";
export const CART_DELETE_SUCCESS = "CART_DELETE_SUCCESS";
export const CART_DELETE_ERROR = "CART_DELETE_ERROR";
